<div class="row">

  <div class="col-10">

  </div>
  <div class="col-12 no-padding">
    <div class="row justify-content-center no-padding">
      <h2 class="col-12 titleBookk"><b>{{ 'RESERVATION.TITLE' | translate }}</b></h2>
      <div class="col-10 margin-block-s">
        <ng-template [ngIf]="book !== null">
          <mat-card class="box-shadow margin-block-s d-none d-lg-block ">
            <div class="row  justify-content-center">
              <h2 class="col-12 blod">{{ 'RESERVATION.PROGRESS.TITLE' | translate }}</h2>

              <div class="col-10">
                <app-book-info-block [book]="book"></app-book-info-block>
              </div>
              <button mat-flat-stroke color="primary" class="col-2">{{ 'RESERVATION.PROGRESS.ADD' | translate }}</button>
            </div>

          </mat-card>
        </ng-template>
      </div>
      <!-- Mes réservations à venir -->
      <div class="col-12 margin-block-s">
        <mat-card class="row  justify-content-center box-shadow margin-block-s d-none d-lg-block">
          <h3 class="col-12 bold ">{{ 'RESERVATION.COME.TITLE' | translate }}</h3>
          <ng-template [ngIf]="nextLoaded" [ngIfElse]="nextLoading">
            <app-book-table *ngIf='bookList["next"] != null' [bookList]="bookList['next']"></app-book-table>
          </ng-template>
          <ng-template #nextLoading>
            <mat-spinner style="margin: auto;"></mat-spinner>
          </ng-template>

        </mat-card>
        <mat-card class="row d-lg-none margin-block-s">
            <h3 class="col-12 bold ">{{ 'RESERVATION.COME.TITLE' | translate }}</h3>
            <ng-template [ngIf]="nextLoaded" [ngIfElse]="nextLoading">
              <app-book-table *ngIf='bookList["next"] != null' [bookList]="bookList['next']"></app-book-table>
            </ng-template>
            <ng-template #nextLoading>
              <mat-spinner style="margin: auto;"></mat-spinner>
            </ng-template>
          </mat-card>
      </div>
       <!-- Mes réservations à venir -->


       <!-- Mes réservations actuelles -->
      <div class="col-12 margin-block-s">
        <mat-card class="row  justify-content-center box-shadow margin-block-s d-none d-lg-block">
          <h3 class="col-12 bold ">{{ 'RESERVATION.PROGRESS.TITLE' | translate }}</h3>
          <ng-template [ngIf]="nextLoaded" [ngIfElse]="nextLoading">
            <app-book-table *ngIf='bookList["now"] != null' [bookList]="bookList['now']"></app-book-table>
          </ng-template>
          <ng-template #nextLoading>
            <mat-spinner style="margin: auto;"></mat-spinner>
          </ng-template>

        </mat-card>
        <mat-card class="row d-lg-none margin-block-s">
            <h3 class="col-12 bold ">{{ 'RESERVATION.PROGRESS.TITLE' | translate }}</h3>
            <ng-template [ngIf]="nextLoaded" [ngIfElse]="nextLoading">
              <app-book-table *ngIf='bookList["now"] != null' [bookList]="bookList['now']"></app-book-table>
            </ng-template>
            <ng-template #nextLoading>
              <mat-spinner style="margin: auto;"></mat-spinner>
            </ng-template>
          </mat-card>
      </div>
       <!-- Mes réservations actuelles -->


      <div class="col-12 margin-block-s">
        <mat-card class="row  justify-content-center box-shadow margin-block-s d-none d-lg-block">
          <h3 class="col-12 bold ">{{ 'RESERVATION.CLOSED.TITLE' | translate }}</h3>
          <ng-template [ngIf]="oldLoaded" [ngIfElse]="oldLoading">
            <app-book-table *ngIf='bookList["last"] != null' [bookList]="bookList['last']"></app-book-table>
          </ng-template>
          <ng-template #oldLoading>
            <mat-spinner style="margin: auto"></mat-spinner>
          </ng-template>
        </mat-card>
        <mat-card class="row d-lg-none margin-block-s">
            <h2 class="col-12">{{ 'RESERVATION.CLOSED.TITLE' | translate }}</h2>
            <ng-template [ngIf]="oldLoaded" [ngIfElse]="oldLoading">
              <app-book-table *ngIf='bookList["last"] != null' [bookList]="bookList['last']"></app-book-table>
            </ng-template>
            <ng-template #oldLoading>
              <mat-spinner style="margin: auto"></mat-spinner>
            </ng-template>
          </mat-card>
      </div>
      <!-- 

    </div> 
  </div> -->


    </div>